<template>
  <v-list class="list pa-0">
    <activity-item v-for="activity in activities" :key="activity.id" :activity="activity" />
  </v-list>
</template>

<script>
import ActivityItem from "@/components/activities/ActivityItem.vue"

export default {
  components: {
    ActivityItem
  },
  props: {
    activities: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.activity-item-container:last-child) {
  .v-divider {
    display: none;
  }
}
</style>
